import { PERMISSIONS, type Permission } from '@tempo-io/permissions';
import { z } from 'zod';

export const permissionsResponseDTOSchema = (() => {
  const schema = {} as { [K in Permission]: z.ZodBoolean };

  for (const permission of Object.values(PERMISSIONS)) {
    schema[permission] = z.boolean();
  }
  return z.object(schema).strict();
})();

export type PermissionsResponseDTO = z.infer<typeof permissionsResponseDTOSchema>;
